import { UseCase } from '@/core/base/use-case';
import { Observable } from 'rxjs';
import { CitiesRepository } from '../repositories/cities.repository';
import { CitiesResponse } from '../models/cities.model';

export class GetCitiesUseCase implements UseCase<never, CitiesResponse> {
    constructor(private readonly repository: CitiesRepository) {}

    execute(): Observable<CitiesResponse> {
        return this.repository.getCities();
    }
}
